import React, { createContext, useState, useEffect, useContext } from 'react';

// Создаем контекст темы
export const ThemeContext = createContext();

// Цветовые схемы для обеих тем
export const themes = {
  light: {
    primary: '#1A56DB',
    secondary: '#7E22CE',
    background: '#F5F7FA',
    surface: '#FFFFFF',
    text: '#111827',
    textSecondary: '#4B5563',
    accent1: '#1A56DB',
    accent2: '#7E22CE',
    border: '#E5E7EB',
    hover: '#F3F4F6',
    shadow: 'rgba(0, 0, 0, 0.1)'
  },
  dark: {
    primary: '#00F0FF',
    secondary: '#FF00F5',
    background: '#050505',
    surface: '#0A0A0A',
    text: '#FFFFFF',
    textSecondary: '#9CA3AF',
    accent1: '#00F0FF',
    accent2: '#FF00F5',
    border: '#1F2937',
    hover: '#111827',
    shadow: 'rgba(0, 240, 255, 0.2)'
  }
};

export const ThemeProvider = ({ children }) => {
  // Установка темы по умолчанию - светлая
  const [currentTheme, setCurrentTheme] = useState('light');
  
  // Получаем сохраненную тему из localStorage при инициализации
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setCurrentTheme(savedTheme);
    } else {
      // Если тема не сохранена, устанавливаем светлую тему по умолчанию
      localStorage.setItem('theme', 'light');
      document.documentElement.classList.remove('dark');
    }
  }, []);
  
  // Функция переключения темы
  const toggleTheme = () => {
    const newTheme = currentTheme === 'light' ? 'dark' : 'light';
    setCurrentTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    
    // Обновляем тему документа для применения стилей Tailwind
    if (newTheme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };
  
  // Применяем тему при изменении currentTheme
  useEffect(() => {
    if (currentTheme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    
    // Обновляем мета-тег для цвета темы мобильного браузера
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute(
        'content',
        currentTheme === 'light' ? '#FFFFFF' : '#050505'
      );
    }
  }, [currentTheme]);
  
  return (
    <ThemeContext.Provider value={{ theme: themes[currentTheme], currentTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Хук для использования темы в компонентах
export const useTheme = () => useContext(ThemeContext);